import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { CREATOR_STATUS_FILL, CREATOR_STATUS_ORDER, fmtNum, humanize } from "./format";
import type { RawCreatorStatus } from "./types";

/** Stacked analysis bar: accepted / rejected / errored / duplicate over the
 *  total, PENDING is the empty track. */
export function StatusBar({
  counts,
  total,
  className,
}: {
  counts: Record<RawCreatorStatus, number>;
  total: number;
  className?: string;
}) {
  return (
    <div className={cn("flex h-2.5 w-full overflow-hidden rounded-pill bg-primary/10", className)}>
      {CREATOR_STATUS_ORDER.filter((s) => s !== "PENDING" && counts[s] > 0).map((status) => (
        <Tooltip key={status}>
          <TooltipTrigger asChild>
            <div
              className={cn("h-full transition-[width]", CREATOR_STATUS_FILL[status])}
              style={{ width: `${(counts[status] / Math.max(total, 1)) * 100}%` }}
            />
          </TooltipTrigger>
          <TooltipContent>
            {humanize(status.toLowerCase())}: {fmtNum(counts[status])}
          </TooltipContent>
        </Tooltip>
      ))}
    </div>
  );
}
